


import React  from 'react';

import {
  MdClearAll  
} from 'react-icons/md';
import {
  Button,
  Nav,
  Navbar,
  NavItem,
  NavLink,
} from 'reactstrap';
import bn from '../../utils/bemnames';
import './Header.css'
const bem = bn.create('header');



class Header extends React.Component {
  state = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };


  Logout = () => {
    sessionStorage.removeItem('QaInsptid')
    sessionStorage.removeItem('QainspectId')
    sessionStorage.removeItem('username')
    sessionStorage.removeItem('userid')
    sessionStorage.removeItem('email')
    sessionStorage.removeItem('user')
    sessionStorage.removeItem('ponum')
    sessionStorage.removeItem('cateid')
    sessionStorage.removeItem('usertype')
    sessionStorage.removeItem('pono')
    sessionStorage.removeItem('authtoken')
  }

  render() {
    const { isNotificationConfirmed } = this.state;
    // const [{ user } , dispatch] = useStateValue();
    // const [userinf, setuserinf] = useState([])
    // useEffect(() => {
    //  setuserinf(user)
    // }, [user])
    return (


      <div className='headers1' >


        <Navbar light expand className={`${bem.b('bg-white')} headers1`} >

          <Nav navbar className="mr-2">
            <Button outline onClick={this.handleSidebarControlButton}>
              <MdClearAll size={25} />
            </Button>
          </Nav>
          <Nav navbar>
            {/* <SearchInput /> */}
          </Nav>

          <Nav navbar className={bem.e('nav-right')}>


            <NavItem>
              {/* <NavLink id="Popover2">                          
               { sessionStorage.getItem('Usercode')}
               <br/>
               
               <span style={{ fontSize: '12px' }}>
    {sessionStorage.getItem('CompanyName')}
  </span>
            </NavLink> */}
              <NavLink id="Popover2">
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                  <span style={{ textTransform: 'uppercase', color: 'orange', fontWeight: 'bold' }}>
                    Welcome - {sessionStorage.getItem('Username')}
                  </span>
                  <span style={{ fontSize: '12px', textTransform: 'uppercase', color: 'orange', fontWeight: 'bold' }}>
                    {sessionStorage.getItem('CustomerName')}
                  </span>
                </div>

              </NavLink>

              {/* {userinf.map((data) => (
              <p>{data.LoginName}</p>
            ))} */}
              {/* <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250 }}
            > */}

              {/* <PopoverBody className="p-0 border-light">
                <UserCard
                  title={ sessionStorage.getItem('username')}
                  subtitle={ sessionStorage.getItem('email')}
                  
                  className="border-light"
                >
                  <ListGroup flush>
                    <Link to="/">
                    <ListGroupItem tag="button" action className="border-light" onClick={this.Logout}>
                      <MdExitToApp /> Signout
                    </ListGroupItem>

                    </Link>
                  </ListGroup>
                </UserCard>
              </PopoverBody>
            </Popover> */}
            </NavItem>
          </Nav>
        </Navbar>
      </div>
    );
  }
}

export default Header;
